var map = {
	"./Artiflex.png": 9388,
	"./STAAR.png": 6573,
	"./STAAR0.png": 781,
	"./STAAR120.png": 7257,
	"./STAAR150.png": 6760,
	"./STAAR30.png": 7495,
	"./STAAR60.png": 1251,
	"./STAAR90.png": 8023,
	"./Standard.png": 1411,
	"./graphicArtiflex.png": 6192,
	"./graphicSTAAR.png": 4369,
	"./graphicSTAAR0.png": 2673,
	"./graphicSTAAR120.png": 566,
	"./graphicSTAAR150.png": 1847,
	"./graphicSTAAR30.png": 8271,
	"./graphicSTAAR60.png": 3684,
	"./graphicSTAAR90.png": 6818,
	"./graphicStandard.png": 1572,
	"./questionmark.png": 4129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9432;